import React, { useState } from "react"
import styled from "styled-components"
import HexMotivation from "../../../public/assets/imgs/Hexagon-Motivation.svg"
import HexGE from "../../../public/assets/imgs/Hexagon-GE.svg"
import HexGEM from "../../../public/assets/imgs/Hexagon-GE-M.svg"
import HexWork from "../../../public/assets/imgs/Hexagon-Work.svg"
import HexWorkM from "../../../public/assets/imgs/Hexagon-Work-M.svg"
import HexSmall from "../../../public/assets/imgs/hexagon-small.svg"

import HexLargeLight from "../../../public/assets/imgs/hexagon-light.svg"
import HexSmallLight from "../../../public/assets/imgs/hexagon-small-light.svg"
import HexMediumLight from "../../../public/assets/imgs/hexagon-medium-light.svg"

import { DescriptivePoints } from "../DescriptivePoints"
import { Grid } from "antd"
import useDeviceTheme from "@project/shared/src/useDeviceTheme"

const Container = styled.div<any>`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .inner-hexagon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 70%;
    text-align: center;
    @media (max-width: 340px) {
      margin-top: -30px;
    }
    img {
      width: 80px;
      height: 80px;
      @media (max-width: 768px) {
        height: 40px;
        width: 40px;
      }
      @media (max-width: 1200px) {
        height: 32px;
        width: 32px;
      }
    }

    .title {
      font-family: "Montserrat", sans-serif;
      color: ${(props) => props.theme.whiteTitle};
      text-align: center;
      font-weight: 600;
      font-size: 1.375rem;
      margin: 30px 0 5px 0;
      line-height: 33px;
      @media (max-width: 340px) {
        font-size: 1rem;
        margin: 10px 0;
      }
      @media (max-width: 1200px) {
        font-size: 14px;
        line-height: 21px;
      }
    }
  }
`
const { useBreakpoint } = Grid
interface IHexagonProps {
  type: string
  className: any
}

const Hexagon: React.FC<IHexagonProps> = ({ type, className }) => {
  const breakPoint = useBreakpoint()
  const isDarkTheme = useDeviceTheme()
  const contents = {
    motivation: {
      image: "/assets/imgs/bulb.svg",
      imageOnHover: "/assets/imgs/bulb-hover.svg",
      title: "Motivation",
      array: [
        { id: 1, value: "Competitive Salary" },
        { id: 2, value: "MacBook Air device" },
        { id: 3, value: "Employee of the month opportunity" },
        { id: 4, value: "Performance Evaluation twice a year" },
        { id: 5, value: "Lunch and other Allowances" },
      ],
    },
    growth: {
      image: "/assets/imgs/plants-image.svg",
      imageOnHover: "/assets/imgs/plants-image-hover.svg",
      title: "Self Growth",
      array: [
        { id: 1, value: "R&D on various domains" },
        { id: 2, value: "Leadership challenges" },
      ],
    },
    entertainment: {
      image: "/assets/imgs/entertainment.svg",
      imageOnHover: "/assets/imgs/entertainment-hover.svg",
      title: "Entertainment",
      array: [
        { id: 1, value: "Frequent outings" },
        { id: 2, value: "Team building activities" },
      ],
    },
    workLife: {
      image: "/assets/imgs/smiley-face.svg",
      imageOnHover: "/assets/imgs/smiley-face-hover.svg",
      title: "Work - Life Balance",
      array: [
        { id: 1, value: "5 working days a week" },
        { id: 2, value: "Work from home" },
      ],
    },
  }

  const [isHovered, setIsHovered] = useState<boolean>(false)

  const handleMouseEnter = () => {
    setIsHovered(true)
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  const isXs = breakPoint.xs
  const isMdOnly = breakPoint.md && !breakPoint.xl
  const isLg = breakPoint.xl

  let HexIcon = HexSmall // default fallback

  if (isXs) {
    HexIcon = isDarkTheme ? HexSmall : HexSmallLight
  } else if (isMdOnly) {
    if (type === "motivation") {
      HexIcon = isDarkTheme ? HexSmall : HexMediumLight
    } else if (type === "growth" || type === "entertainment") {
      HexIcon = isDarkTheme ? HexGEM : HexMediumLight
    } else if (type === "workLife") {
      HexIcon = isDarkTheme ? HexWorkM : HexMediumLight
    } else {
      HexIcon = isDarkTheme ? HexSmall : HexSmallLight
    }
  } else if (isLg) {
    if (type === "motivation") {
      HexIcon = isDarkTheme ? HexMotivation : HexLargeLight
    } else if (type === "growth" || type === "entertainment") {
      HexIcon = isDarkTheme ? HexGE : HexLargeLight
    } else if (type === "workLife") {
      HexIcon = isDarkTheme ? HexWork : HexLargeLight
    } else {
      HexIcon = isDarkTheme ? HexSmall : HexSmallLight
    }
  } else {
    // Fallback for screen sizes not covered
    HexIcon = isDarkTheme ? HexSmall : HexSmallLight
  }

  return (
    <Container
      className={`hexagon ${className}`}
      type={type}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="first-image">{<HexIcon />}</div>
      <div className="inner-hexagon">
        <img
          src={
            isHovered ? contents?.[type]?.imageOnHover : contents?.[type]?.image
          }
          alt=""
        />
        <span className="title">{contents?.[type]?.title}</span>
        <DescriptivePoints itemArray={contents?.[type]?.array} />
      </div>
    </Container>
  )
}

export { Hexagon }
